import { FC } from "react";
import { Button, ButtonVariant, Modal } from "shared/components";
import { CreditCardCheck, Users01 } from "untitledui-js-base";

type Props = {
  opened: boolean;
  onClose: () => void;
  onReportAll: () => void;
  paidOnTime: number;
  needToReportCount: number;
};

export const ReportModal: FC<Props> = ({
  opened,
  onClose,
  onReportAll,
  paidOnTime,
  needToReportCount
}) => {
  return (
    <Modal opened={opened} onClose={onClose} panelClassName="p-6">
      <h2 className="text-content-1000 font-bold text-xl mb-2 text-center">
        Report rent payments?
      </h2>
      <p className="text-content-500 text-base">
        We will report this data to the credit bureaus
      </p>
      <div className="border-b border-alpha-40 my-6" />
      <div className="flex gap-2 mb-4">
        <Users01 size="20" className="stroke-content-300" />
        <p className="text-content-1000 text-sm font-medium">
          <span className="font-bold">{needToReportCount || 0}</span> Renters
        </p>
      </div>
      <div className="flex gap-2 mb-6">
        <CreditCardCheck size="20" className="stroke-content-300" />
        <p className="text-content-1000 text-sm font-medium">
          <span className="font-bold">{paidOnTime || 0}</span> paid on-time,{" "}
          <span className="font-bold">
            {needToReportCount - paidOnTime || 0}
          </span>{" "}
          late payment
        </p>
      </div>
      <div className="flex gap-2 mb-4">
        <div className="w-full">
          <Button className="w-full" onClick={onClose}>
            Cancel
          </Button>
        </div>
        <div className="w-full">
          <Button
            variant={ButtonVariant.PRIMARY}
            className="w-full"
            onClick={onReportAll}
          >
            Report
          </Button>
        </div>
      </div>
    </Modal>
  );
};
